import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import zhTW from '../locales/zh-TW.json';
import esMX from '../locales/es-MX.json';
import frCA from '../locales/fr-CA.json';

/**
 * react-i18next bootstrap.
 *
 * 主：en-US；次：zh-TW、es-MX、fr-CA（皆已實作）。
 * fr-CA 為魁北克 Law 25 合規必備語系；es-MX 為北美西語擴充市場。
 */

export const SUPPORTED_LANGS = ['en', 'zh-TW', 'es-MX', 'fr-CA'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-TW': { translation: zhTW },
      'es-MX': { translation: esMX },
      'fr-CA': { translation: frCA },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tarot.lang',
    },
  });

export default i18n;
